interface Options {
    url: string;
    protocols?: string;
    heart?: number;
    reconnect?: number;

    call?(sting): void;
}

export class WebSocketCreater {
    public par: Options;
    public keepalive: boolean = true;
    public wsProgram;

    private serverTimeoutObj: any;
    private timeoutObj: any;
    private timeoutReconnect: any;
    private lockReconnect: boolean;

    public constructor(params: Options) {
        this.serverTimeoutObj = null;
        this.timeoutObj = null;
        this.timeoutReconnect = null;
        this.lockReconnect = false;
        this.wsProgram = null;
        this.par = {
            url: '',
            protocols: undefined,
            call: undefined,
            heart: 30000,
            reconnect: 4000,
        };
        this.par = Object.assign(this.par, params);
        this.createWebSocket();
    }

    public closeWS() {
        this.keepalive = false;
        if (this.wsProgram.readyState === 1) {
            this.wsProgram.close();
        }
    }

    private createWebSocket() {
        try {
            this.wsProgram = new WebSocket(this.par.url, this.par.protocols);
            this.init(this.par.call);
        } catch (e) {
            console.log(e);
            this.reconnect();
        }
    }

    private init(call: (sting) => void) {
        this.wsProgram.onopen = () => {
            this.wsProgram.send('1');
            this.heartCheck();
        };

        this.wsProgram.onmessage = (evt) => {
            const res = JSON.parse(evt.data);
            call(res);
            this.heartCheck();
        };

        this.wsProgram.onclose = () => {
            if (this.keepalive) {
                this.reconnect();
            } else {
                // console.log('closed!');
            }
        };
    }

    private heartCheck() {
        if (this.keepalive) {
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            this.timeoutObj = setTimeout(() => {
                if (this.wsProgram.readyState === 1) {
                    this.wsProgram.send('1');
                    this.serverTimeoutObj = setTimeout(() => {
                        this.wsProgram.close();
                    }, this.par.heart);
                }
            }, this.par.heart);
        }
    }

    private reconnect() {
        if (this.lockReconnect) {
            return;
        }
        this.lockReconnect = true;
        clearTimeout(this.timeoutReconnect);
        this.timeoutReconnect = setTimeout(() => {
            this.createWebSocket();
            this.lockReconnect = false;
        }, this.par.reconnect);
    }

}
